import { defineMessages } from 'react-intl';

const definedMessages = defineMessages({
  welcome: {
    id: 'app.signup.confirmation.welcome',
    description: 'Text to welcome the user to Tanda',
    defaultMessage: 'Welcome to your new time clock!',
  },
  carouselContext: {
    id: 'app.signup.confirmation.carousel_context',
    description: 'To introduce the carousel, how to Tanda works',
    defaultMessage: "Here's how to use it",
  },
});

export default definedMessages;



// WEBPACK FOOTER //
// ./src/components/sign_up/sign_up_confirmation/i18n.js